export default __webpack_public_path__ + "static/media/accedi-area-docente-nc.52a17981.svg";